import styled from "styled-components";

export const Heading = styled.h1`
  text-align: center;
  color: green;
`;

export const Content = styled.div`
  overflowy: scroll;
  height: 2500px;
`;

export const Button = styled.div`
  position: fixed;
  width: 100%;
  left: 93%;
  bottom: 180px;
  height: 20px;
  font-size: 2.5rem;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  z-index: 1;
  cursor: pointer;
  color: black;
`;
